export default function getUrlStatus() {
  const url = window.document.location.href;
  if (url.includes("preview")) return "preview";
  return "live";
}
